exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-star[data-v-bec171e2] {\n  border: 1px solid #dedede;\n  padding: 5px 5px 5px 5px;\n}\n.not-star .ivu-form-item-required .ivu-form-item-label[data-v-bec171e2]:before {\n  content: \"\";\n}\n.not-star .ivu-form-item[data-v-bec171e2] {\n  margin-bottom: 6px;\n}\n.search-card[data-v-bec171e2] {\n  padding: 10px;\n  margin-bottom: 5px;\n}\n.search-btn[data-v-bec171e2] {\n  margin-top: 5px;\n}\n", ""]);

// exports
